/**

// Check if debug mode is enabled (global)
const urlParams = new URLSearchParams(window.location.search);

 * Magic-Link Authentication Frontend
 * Manages auth UI state and logout functionality
 */

// BEGIN MAGIC LINK

$(document).ready(function() {
    
    /**
     * Check if user is authenticated using server-provided data
     */
    function isAuthenticated() {
        return window.SERVER_AUTH_STATUS && window.SERVER_AUTH_STATUS.isAuthenticated;
    }
    
    /**
     * Get email from server-provided data
     */
    function getEmailFromToken() {
        if (window.SERVER_AUTH_STATUS && window.SERVER_AUTH_STATUS.userEmail) {
            return window.SERVER_AUTH_STATUS.userEmail;
        }
        return null;
    }

    /**
     * Log authentication status to console
     */
    // Track previous auth state to only log changes
    let lastAuthState = null;
    
    function logAuthStatus() {
        const isAuth = isAuthenticated();
        const email = isAuth ? getEmailFromToken() : null;
        const currentState = `${isAuth}:${email || 'guest'}`;
        
        // Only log if auth status actually changed
        if (lastAuthState !== currentState) {
            if (debugMode === '1') {
            }
            lastAuthState = currentState;
        }
    }
    
    /**
     * Update navbar based on authentication status
     */
    function updateAuthUI() {
        const isAuth = isAuthenticated();
        const loginItem = document.getElementById('auth-login-item');
        const loginLink = loginItem ? loginItem.querySelector('a') : null;
        const userMenuRoot = document.getElementById('user-menu');
        const userMenuLi = userMenuRoot ? userMenuRoot.closest('.nav-item') : null;
        
        if (isAuth) {
            // Remove 'pu' parameter from URL if present (public only filter is not needed for authenticated users)
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('pu')) {
                urlParams.delete('pu');
                const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '') + window.location.hash;
                window.history.replaceState({}, '', newUrl);
            }
            
            if (loginItem) { loginItem.style.display = 'none'; }
            if (userMenuRoot) {
                userMenuRoot.style.display = 'block';
                userMenuRoot.classList.remove('is-guest');
            }
            if (userMenuLi) {
                userMenuLi.style.display = 'block';
            }
        } else {
            if (loginItem) { loginItem.style.display = 'block'; }
            // Update login link with current URL as next parameter (for guests)
            if (loginLink) {
                const currentUrl = encodeURIComponent(window.location.pathname + window.location.search);
                loginLink.href = `/login?next=${currentUrl}`;
                // Remove target="_blank" if present (for guests, login should open in same tab)
                loginLink.removeAttribute('target');
            }
            if (userMenuRoot) {
                userMenuRoot.style.display = 'block';
                userMenuRoot.classList.add('is-guest');
            }
            if (userMenuLi) {
                userMenuLi.style.display = 'block';
            }
        }

        logAuthStatus();
    }
    
    /**
     * Logout user
     */
    function logout() {
        // Remove session cookie
        document.cookie = 'session=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        
        // Clear localStorage
        localStorage.clear();
        
        // Log logout to console
        if (debugMode === '1') {
                if (debugMode === '1') {
                console.log('User logged out');
            }
            }
        if (window.HyperLog) {
            HyperLog.info('User logged out', {}, 'auth');
        }
        
        // Redirect to login page
        window.location.href = '/login';
    }
    
    /**
     * Show toast notification
     */
    function showToast(message, type = 'info') {
        // Create toast container if it doesn't exist
        let toastContainer = document.querySelector('.toast-container');
        if (!toastContainer) {
            toastContainer = document.createElement('div');
            toastContainer.className = 'toast-container position-fixed top-0 end-0 p-3';
            toastContainer.style.zIndex = '1050';
            document.body.appendChild(toastContainer);
        }
        
        const toastId = 'toast-' + Date.now();
        const bgClass = type === 'success' ? 'bg-success' : 
                       type === 'error' ? 'bg-error' : 'bg-info';
        
        const toastHtml = `
            <div id="${toastId}" class="toast ${bgClass} text-canvas" role="alert">
                <div class="d-flex">
                    <div class="toast-body">
                        ${message}
                    </div>
                    <button type="button" class="btn-close btn-close-white me-2 m-auto" 
                            data-bs-dismiss="toast"></button>
                </div>
            </div>
        `;
        
        toastContainer.insertAdjacentHTML('beforeend', toastHtml);
        
        const toastElement = document.getElementById(toastId);
        const toast = new bootstrap.Toast(toastElement, {
            autohide: true,
            delay: 5000
        });
        
        toast.show();
        
        // Remove toast element after hiding
        toastElement.addEventListener('hidden.bs.toast', () => {
            toastElement.remove();
        });
    }
    
    // Initialize auth UI
    updateAuthUI();
    
    // Ensure Bootstrap dropdowns are initialized
    if (typeof bootstrap !== 'undefined') {
        // Initialize all dropdowns
        const dropdownElementList = document.querySelectorAll('.dropdown-toggle');
        const dropdownList = [...dropdownElementList].map(dropdownToggleEl => new bootstrap.Dropdown(dropdownToggleEl));
    }
    
    // Removed bindings for deprecated navbar user menu elements (migrated to #user-menu)
    
    // Check auth status periodically (in case token expires)
    setInterval(updateAuthUI, 300000); // Check every 5 minutes
    
    // Export functions for global use
    window.AuthManager = {
        isAuthenticated: isAuthenticated,
        getEmailFromToken: getEmailFromToken,
        updateAuthUI: updateAuthUI,
        logout: logout,
        showToast: showToast,
        logAuthStatus: logAuthStatus
    };

    // Log initial auth status
    logAuthStatus();
});

// END MAGIC LINK 